class Model {
  constructor() {
  }
  static getObjByCode(code, arr) {
    var foundObj = null
    for (const obj of arr) {
      if (obj.code === code) {
        foundObj = obj
        break
      }
    }
    return foundObj
  }
  static getObjByName(name, arr) {
    var foundObj = null
    for (const obj of arr) {
      if (obj.name === name) {
        foundObj = obj
        break
      }
    }
    return foundObj
  }
}

export default Model
